var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "block1" },
        [
          _vm.$slots.default
            ? [
                _c(
                  "div",
                  { on: { click: _vm.openGlobalModal } },
                  [_vm._t("default")],
                  2
                ),
              ]
            : [
                _c("LoadingButton", {
                  attrs: {
                    title:
                      '<i class="icon-fa icon-fa-microphone-slash text-center"></i>',
                    className: "btn btn-dark btn-lg",
                    onClick: () => _vm.openGlobalModal(),
                    loading: _vm.loading,
                    color: "black",
                  },
                }),
              ],
          _vm._v(" "),
          _vm.blackList && _vm.blackList.comments
            ? _c("span", { staticClass: "badge-number badge badge-danger" }, [
                _vm._v(_vm._s(_vm.blackList.comments.length)),
              ])
            : _vm._e(),
        ],
        2
      ),
      _vm._v(" "),
      _vm.open
        ? _c("PhoneBlackListEditModal", {
            attrs: {
              newRecord: _vm.blackList || { phone_num: _vm.phone.full_phone },
              onCancel: (comment) => this.closeModal(comment),
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }